export default function BCMFrameworkSection() {
  return (
    <section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-slate-900" data-testid="bcm-framework-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-white tracking-tight mb-4">
            Follow the BCI Professional Practices Lifecycle
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Our platform guides you through the complete BRM Framework using the 
            Plan-Do-Check-Act (PDCA) cycle for continuous improvement.
          </p>
        </div>
        <div className="flex justify-center">
          <div className="relative max-w-3xl w-full">
            <img
              src="https://customer-assets.emergentagent.com/job_resiliencemanage/artifacts/v6u3wxtc_PDCA%20BRM%20Decent-A.png"
              alt="BRM Framework - Plan Do Check Act Cycle"
              className="w-full h-auto rounded-2xl shadow-2xl"
              data-testid="bcm-framework-diagram"
            />
            <div className="absolute inset-0 rounded-2xl ring-1 ring-white/10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
